import { useAuth } from "@/contexts/AuthContext";
import { useSuperAdmin } from "@/hooks/useSuperAdmin";
import { isBillingLockedForViewer } from "@/lib/agency-billing";

export function useAgencyBillingLock() {
  const { billingManagedByAgency, isMatrixDelegate } = useAuth();
  const { isSuperAdmin, loading } = useSuperAdmin();
  const candidate = isBillingLockedForViewer({ billingManagedByAgency, isMatrixDelegate, isSuperAdmin: false });

  return {
    locked: candidate && (loading || !isSuperAdmin),
    loading: candidate && loading,
  };
}
